<div class="row align-items-center mx-1 mb-2 py-2 bg-light">
  <div class="col-auto" style="width: 4rem"><span class="fa fa-2x" (click)="toggleOrder()"
                                                  [ngClass]="reverseOrder ? 'fa-caret-up' : 'fa-caret-down'"></span>
  </div>
  <div class="col" style="max-width: 12rem">Timestamp</div>
  <div class="col">Action</div>
  <div class="col-auto" style="width: 20rem">User</div>
  <div class="col-auto" style="width: 20rem">Organisation</div>
</div>

@for (item of reverseOrder ? items.slice().reverse() : items; track item; let index = $index) {
  <ng-container [ngTemplateOutlet]="itemTemplate"
                [ngTemplateOutletContext]="{ item : item, index: reverseOrder ? items.length - index - 1 : index }"></ng-container>
}

<ng-template #itemTemplate let-logItem="item" let-index="index">
  @if (cast(logItem); as item) {
    <div class="text-dark always-enabled">
      <div class="row align-items-start item mx-1 my-2 py-2 border border-light">
        <div class="col-auto" style="width: 4rem">
          {{ index + 1 }}.
        </div>
        <div class="col" style="max-width: 12rem">
          <app-date-field [readonly]="true" [ngModel]="item.timestamp"></app-date-field>
        </div>
        <div class="col angular-with-newlines">{{ item.description }}</div>
        <div class="col-auto" style="width: 20rem">
          {{ item.user || '' }}
        </div>
        <div class="col-auto" style="width: 20rem">
          {{ item.fullName }}
        </div>
      </div>
    </div>
  }
</ng-template>
